<script>
import { isMagasinOpened } from "@/utils/magasin";

export default {
  props: {
    magasin: {
      type: Object,
      required: false,
      default: null
    }
  },
  computed: {
    exceptionalOpening() {
      const exceptionalDays = this.magasin.attributes
        .horaires_exceptionnels_table
        ? this.magasin.attributes.horaires_exceptionnels_table.find(
            (e) => e.type === "Magasin"
          )
        : [];
      return (
        exceptionalDays &&
        exceptionalDays.horaires.filter((e) => e.type === "Ouverture")
      );
    },
    exceptionalClosure() {
      const exceptionalDays = this.magasin.attributes
        .horaires_exceptionnels_table
        ? this.magasin.attributes.horaires_exceptionnels_table.find(
            (e) => e.type === "Magasin"
          )
        : [];
      return (
        exceptionalDays &&
        exceptionalDays.horaires.filter((e) => e.type === "Fermeture")
      );
    },
    shopTimetable() {
      const shopTimetable =
        this.magasin.attributes.horaires_table &&
        this.magasin.attributes.horaires_table.find(
          (e) => e.type === "Magasin"
        );
      return shopTimetable;
    },
    horairesMagasin() {
      return this.magasin.attributes.horaires;
    },
    isOpen() {
      return isMagasinOpened(this.magasin);
    }
  }
};
</script>

<template>
  <div>
    <p class="u-font-15 u-font-500 u-mb-xxs">
      <strong>Horaires</strong>
    </p>
    <template v-for="(item, index) in shopTimetable.timetable">
      <div
        v-if="item.jour && (item.from || item.to)"
        :key="index"
        class="u-flex u-flex-justify-between u-font-15"
        :class="
          index !== shopTimetable.timetable.length - 1
            ? 'u-mb-xxs'
            : 'u-mb-md'
        "
      >
        <p v-if="item.jour">
          {{ item.jour }}
        </p>
        <p v-if="item.from == '00:00' && item.to == '00:00'">
          Fermé
        </p>
        <p v-else-if="item.from && item.to">
          {{ item.from }} - {{ item.to }}
        </p>
        <p v-else-if="item.from">
          {{ item.from }}
        </p>
        <p v-else-if="item.to">
          {{ item.to }}
        </p>
      </div>
    </template>

    <template v-if="exceptionalOpening && exceptionalOpening.length > 0">
      <p class="u-font-15 u-mb-xs">
        <strong class="u-font-500">Ouvertures exceptionnelles</strong>
      </p>
      <p
        v-for="(item, index) in exceptionalOpening"
        :key="item.type + index"
        class="u-color-success u-font-15 "
        :class="
          index !== exceptionalOpening.length - 1 ? 'u-mb-xxs' : 'u-mb-md'
        "
      >
        {{ uppercaseFirstLetter(item.date) }} de {{ item.from }} à
        {{ item.to }}
      </p>
    </template>
    <template v-if="exceptionalClosure && exceptionalClosure.length > 0">
      <p class="u-font-15 u-font-500 u-mb-xs">
        <strong class="u-font-500 ">Fermetures exceptionnelles</strong>
      </p>
      <p
        v-for="(item, index) in exceptionalClosure"
        :key="item.type + index"
        class="u-color-alert u-font-15 "
        :class="
          index !== exceptionalClosure.length - 1 ? 'u-mb-xxs' : 'u-mb-md'
        "
      >
        {{ uppercaseFirstLetter(item.date) }}
      </p>
    </template>
  </div>
</template>
